(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /* ===== MD: o menu do computador so fecha quando o mouse sai (19/09/2026) =====
     Pedido do cliente: em tela menor o painel de ligas nao cabe e rolar pra ver o
     resto fazia o menu sumir. Duas pecas, as duas so no computador e so com mouse:

     1. --ui-mega-altura-max: quanto sobra da barra do menu ate o pe da janela. O
        CSS usa esse valor como teto do painel, que passa a rolar por dentro. E
        refeita na rolagem, no redimensionamento e no fim da transicao do
        cabecalho, porque quando ele gruda no topo a barra sobe e o painel ganha
        espaco.

     2. hide() vira reveal() enquanto o ponteiro esta sobre um item com painel. O
        hide() original tira o cabecalho da tela E chama closeMenuDisclosure(); o
        painel, sendo filho do cabecalho, ia junto. So bloquear o hide nao
        resolveria: sem a classe sticky o cabecalho rola junto com a pagina e sai
        da tela do mesmo jeito (medido ao vivo em 19/09). Revelar prende o
        cabecalho no topo, entao o menu segue na tela por mais que a pagina role.
        Tirou o mouse, o comportamento de antes volta inteiro.

     No celular nada disso liga: a media query exige mouse, e o menu de la e o
     drawer, que nem passa por este codigo. */
  (() => {
    const barra = document.querySelector('.header__inline-menu');
    const cabecalho = document.querySelector('sticky-header');
    if (!barra || !cabecalho) return;

    const noComputador = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const ponteiroNoMenu = () => noComputador.matches && !!barra.querySelector('header-menu:hover');

    const medirAltura = () => {
      if (!noComputador.matches) {
        document.documentElement.style.removeProperty('--ui-mega-altura-max');
        return;
      }
      const sobra = Math.round(window.innerHeight - barra.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--ui-mega-altura-max', Math.max(240, sobra) + 'px');
    };

    let noProximoQuadro = false;
    let aoParar;
    const agendarMedida = () => {
      if (!noProximoQuadro) {
        noProximoQuadro = true;
        requestAnimationFrame(() => {
          noProximoQuadro = false;
          medirAltura();
        });
      }
      /* o cabecalho leva ~200ms pra assentar quando gruda no topo; sem esta
         segunda medida o painel ficava com o teto do meio da animacao (580px em
         vez de 715px, medido em 19/09) */
      window.clearTimeout(aoParar);
      aoParar = window.setTimeout(medirAltura, 300);
    };

    medirAltura();
    window.addEventListener('scroll', agendarMedida, { passive: true });
    window.addEventListener('resize', agendarMedida);
    noComputador.addEventListener('change', medirAltura);

    const secaoCabecalho = document.querySelector('.section-header');
    if (secaoCabecalho) secaoCabecalho.addEventListener('transitionend', medirAltura);

    customElements.whenDefined('sticky-header').then(() => {
      if (typeof cabecalho.hide !== 'function' || typeof cabecalho.reveal !== 'function') return;
      const esconderOriginal = cabecalho.hide.bind(cabecalho);
      const revelarOriginal = cabecalho.reveal.bind(cabecalho);
      cabecalho.hide = function () {
        if (ponteiroNoMenu()) {
          revelarOriginal();
          return;
        }
        esconderOriginal();
      };
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
